// PKCE (RFC 7636) and `state` for the browser-built OAuth authorize URL. The
// BE exchanges the code and requires the matching `codeVerifier` in the
// connect payload, so a code intercepted in the redirect is useless without
// the verifier kept in sessionStorage.
const toBase64Url = (bytes: Uint8Array) =>
  btoa(String.fromCharCode(...bytes))
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=+$/, '');

const randomToken = (byteLength: number) =>
  toBase64Url(crypto.getRandomValues(new Uint8Array(byteLength)));

export const generateCodeVerifier = () => randomToken(64);

export const generateState = () => randomToken(32);

export const generateCodeChallenge = async (codeVerifier: string) => {
  const digest = await crypto.subtle.digest(
    'SHA-256',
    new TextEncoder().encode(codeVerifier)
  );
  return toBase64Url(new Uint8Array(digest));
};
